import React from "react";

const ResultIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.011"
      height="25.398"
      viewBox="0 0 24.011 25.398"
    >
      <g id="db85" transform="translate(-195.376 -184.94)">
        <path
          id="Path_1770"
          data-name="Path 1770"
          d="M414.647,184.94l7.555,6.108-.639,3.187-2.154-.875q-3.077-2.615-6.168-5.213c-.207-.2-.41-.406-.61-.61Z"
          transform="translate(-202.814)"
          fillRule="evenodd"
        />
        <path
          id="Path_1771"
          data-name="Path 1771"
          d="M259.681,242.21q3.04,2.561,6.069,5.135c-.54,3.384-1.421,5.388-2.921,6.954-1.526,1.593-3.736,2.753-6.944,4.357l-.019.01a1.779,1.779,0,0,1-2.508-.384,1.305,1.305,0,0,1-.147-1.121,2.265,2.265,0,0,1,1.121-1.23h.01a37.572,37.572,0,0,0,3.61-2.1,6.58,6.58,0,0,0,1.751-2.39.329.329,0,0,0-.177-.443,6.05,6.05,0,0,1-2.6-1.7c-.248-.275-.42-.51-.57-.689a1.085,1.085,0,0,0-.256-.236.423.423,0,0,0-.217-.069.445.445,0,0,0-.275.079,8.844,8.844,0,0,1-3.374,1.83.328.328,0,0,0-.2.413l.659,1.721h-3.689l-.58-2.43a2.008,2.008,0,0,1,.334-1.121,7.751,7.751,0,0,1,1.121-1.446,10.069,10.069,0,0,1,2.931-2.184Z"
          transform="translate(-49.52 -53.463)"
          fillRule="evenodd"
        />
        <path
          id="Path_1772"
          data-name="Path 1772"
          d="M316.445,344.18c.006.007.013.012.02.02.124.146.309.408.58.708a6.694,6.694,0,0,0,2.518,1.741c-.2.372-.373.645-.531.885h-5.076l-.63-1.633a9.418,9.418,0,0,0,3.118-1.721Z"
          transform="translate(-110.111 -148.656)"
          fillRule="evenodd"
        />
        <path
          id="Path_1773"
          data-name="Path 1773"
          d="M195.376,404.12h13.073a4.014,4.014,0,0,1-.413.364,40.055,40.055,0,0,1-3.541,2.056,2.9,2.9,0,0,0-1.407,1.584,1.963,1.963,0,0,0,.216,1.653,2.44,2.44,0,0,0,3.344.59c1.676-.838,3.091-1.562,4.3-2.3v6.885H195.376Z"
          transform="translate(0 -204.612)"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default ResultIcon;
